import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS } from '@angular/forms';

import { ComparisonDirective } from './comparison.directive';
export class GreaterThanOrEqualToDirective extends ComparisonDirective {
public ngGreaterThanOrEqualTo: any;
constructor() {
    super('ngGreaterThanOrEqualTo');
  }
/**
 * @param {?} control
 * @return {?}
 */
validateCore(control: AbstractControl): boolean {
    return control.value >= this.ngGreaterThanOrEqualTo;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[ngGreaterThanOrEqualTo]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: GreaterThanOrEqualToDirective,
      multi: true
    }
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'ngGreaterThanOrEqualTo': [{ type: Input },],
};
}

function GreaterThanOrEqualToDirective_tsickle_Closure_declarations() {
/** @type {?} */
GreaterThanOrEqualToDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GreaterThanOrEqualToDirective.ctorParameters;
/** @type {?} */
GreaterThanOrEqualToDirective.propDecorators;
/** @type {?} */
GreaterThanOrEqualToDirective.prototype.ngGreaterThanOrEqualTo;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
